import {Component, Input, OnInit} from '@angular/core';
import {DashboardSectionOptions} from './dashboard-section-options';
import {noop} from 'lodash';

@Component({
  selector: 'app-dashboard-section',
  templateUrl: './dashboard-section.component.html',
  styleUrls: ['./dashboard-section.component.scss'],
  providers: [{
    provide: DashboardSectionOptions,
    useClass: DashboardSectionOptions,
  }]
})
export class DashboardSectionComponent implements OnInit {

  @Input()
  name: string;

  @Input()
  gridClass: string;

  @Input()
  toolbar: any[] = [];

  constructor(private options: DashboardSectionOptions) {
  }

  ngOnInit(): void {
    this.toolbar.unshift({
      location: 'before',
      template: this.titleElement(),
    });
    this.options.title = this.name;

    // Set toolbar items listeners
    this.toolbar.forEach((i) => {
      switch (i.widget) {
        case 'dxButtonGroup':
        case 'dxDropDownButton':
          const old = i.options.onItemClick || noop;
          i.options.onItemClick = (e) => {
            this.options.change(i.name, e.itemData);
            old();
          };

      }
    });

  }

  titleElement(): HTMLHeadElement {
    const h = document.createElement('div');
    h.classList.add('toolbar-title');
    h.innerHTML = this.name;
    return h;
  }
}
